'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductDetailsController = function () {
  function ProductDetailsController($scope, $mdDialog) {
    _classCallCheck(this, ProductDetailsController);

    this.svc = {
      $scope: $scope,
      $mdDialog: $mdDialog
    };
  }

  _createClass(ProductDetailsController, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.svc.$mdDialog.hide(null);
    }
  }]);

  return ProductDetailsController;
}();

exports.default = ProductDetailsController;


//////////////////
// WEBPACK FOOTER
// ./product-list/product-details/index.js
// module id = 215
// module chunks = 0